import { keyframes, css } from 'styled-components';

export const spin = () => keyframes`
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
`;

const dash = keyframes`
    0% {
      stroke-dashoffset: -70;
    }
    100% {
      stroke-dashoffset: 0;
    }
`;

/** This is used for Synchronising icon */
export const getSpinAnimation = () => css`
  animation:
    ${spin} 1s linear infinite normal,
    ${dash} 4s linear infinite alternate;
  transform-origin: 50% 50%;
  animation-delay: 0;
  animation-fill-mode: forwards;
  stroke-dasharray: 70;
`;
